module.exports = __webpack_public_path__ + "static/media/L11.561c2b23.jpg";